import React from "react";
import { AreaGL } from "../AreaGL/index";
export const VerticalBand = (props) => {
    const { x, xMapper } = props;
    const getAreaXY = React.useCallback((xPosition, mapper) => {
        return [
            mapper(xPosition[0]),
            -1,
            mapper(xPosition[0]),
            1,
            mapper(xPosition[1]),
            1,
            mapper(xPosition[1]),
            -1,
        ];
    }, []);
    const xy = React.useMemo(() => getAreaXY(x, xMapper), [x, xMapper]);
    return React.createElement(AreaGL, Object.assign({}, props, { domainY: [1, -1], xy: xy }));
};
//# sourceMappingURL=VerticalBand.js.map